import { jsx as _jsx } from "react/jsx-runtime";
import Plotly from "plotly.js-dist-min";
import React, { useEffect, useRef } from "react";
export const DonutChart = ({ colors, height = 280, innerRadius = 0.4, labels, showLegend = false, values, width = 280 }) => {
    const chartRef = useRef(null);
    const data = [
        {
            hole: innerRadius,
            hovertemplate: "<b>%{label}</b><br>%{value}%<br><extra></extra>",
            labels,
            marker: {
                colors,
                line: {
                    color: "#ffffff",
                    width: 2
                }
            },
            textinfo: "none",
            type: "pie",
            values
        }
    ];
    const layout = {
        height,
        margin: { b: 20, l: 20, r: 20, t: 20 },
        paper_bgcolor: "transparent",
        plot_bgcolor: "transparent",
        showlegend: showLegend,
        width
    };
    const config = {
        displayModeBar: false,
        responsive: true,
        staticPlot: false
    };
    useEffect(() => {
        if (chartRef.current) {
            Plotly.newPlot(chartRef.current, data, layout, config);
        }
    }, [colors, height, innerRadius, labels, showLegend, values, width]);
    return _jsx("div", { className: "donut-chart-container w-full h-full", "data-testid": "donut-chart", ref: chartRef });
};
export default DonutChart;
